import axios from 'axios'
import { VALIDATION } from '@/constants'

const verification = {
  /**
   * Looks up consumer based on provided identity.
   * This service returns the idLookupSessionId to be used in getVerificationId.
   *
   * @param {Object} payload
   * @param {Object} payload.consumerIdentity
   * @returns {Promise<Object>}
   */
  lookupSessionId(payload) {
    return axios.post('/api/identities/lookup', payload)
  },

  /**
   * Initializes a verification sequence using the given email address.
   * This service returns the verification id to be used in `verifyCode()`.
   *
   * @param {Object} payload
   * @param {Object} payload.idLookupSessionId
   * @param {Object} payload.requestedValidationChannel
   * @returns {Promise<Object>}
   */
  getVerificationId(payload) {
    return axios.post('/api/identities/verification', payload)
  },

  /**
   * Verifies the user with verificationId and the otp code
   *
   * @param {Object} payload
   * @param {Object} payload.idVerificationId the BE generated verification ID
   * @param {Object} payload.validationData the verification code
   * @returns {Promise<Object>}
   */
  validateCode(payload) {
    return axios.post('/api/identities/validation', payload, { timeout: VALIDATION.TIMEOUT })
  }
}

export default verification
